import React from "react";
import { useSelector } from "react-redux";
import LogoSlider from "../../components/client/LogoSlider";
import Member from "../../components/client/Members";
import ButtonTitle from "../../components/ButtonTitle";
import ArticleCard from "../../components/client/ArticleCard";

function Activities() {
  const posts = useSelector((state) =>
    state.posts?.posts?.filter((post) => post.status === "published")
  );

  const groupPostsByCategory = (posts) => {
    return posts.reduce((acc, post) => {
      const categoryName = post.category?.name || "Chưa phân loại";
      if (!acc[categoryName]) {
        acc[categoryName] = [];
      }
      acc[categoryName].push(post);
      return acc;
    }, {});
  };
  const groupedPosts = groupPostsByCategory(posts);

  return (
    <div>
      <h2 className="text-3xl font-bold">Hoạt động</h2>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-4 mt-3 mb-2">
        <div className="col-span-8">
          {Object.keys(groupedPosts).map((categoryName) => (
            <div key={categoryName}>
              <h2 className=" font-bold mb-4">
                <ButtonTitle title={categoryName} />
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {groupedPosts[categoryName].slice(0, 3).map((article) => (
                  <ArticleCard key={article.id} article={article} />
                ))}
              </div>
            </div>
          ))}
        </div>
        <div className="col-span-4">
          <div className="sticky top-[80px]">
            <ButtonTitle title="Hội viên BCCU mới" />
            <LogoSlider />
          </div>
        </div>
      </div>

      <ButtonTitle title="Hội viên BCCU" />
      <Member />
    </div>
  );
}

export default Activities;
